import { ExtraLanguage } from '../utils/masters';
import { EditionType, Entity, Id, Language, Level, StageType, Translation } from './common.model';

export interface Rate {
  id: Id;
  name: string;
  levelPrices?: Partial<Record<Level, number>>;
  startDate: Date;
  endDate: Date;
  categories: string[];
}

export function getRatePrice(rate: Rate, level?: Level, levelPricesEnabled?: boolean): number {
  const effectiveLevel = levelPricesEnabled ? level : 'ROOKIE';
  if (effectiveLevel && rate.levelPrices?.[effectiveLevel] !== undefined) {
    return rate.levelPrices[effectiveLevel]!;
  }
  return 0;
}

export interface ExtraService {
  id: Id;
  name: string;
  description: string;
  price: number;
  byPerson: boolean;
  maxQuantity: number;
  mandatory: boolean;
  payOffline: boolean;
}
export interface PremiumPack {
  id: Id;
  name: string;
  description: string;
  price: number;
}

export interface ChatGroup extends Entity {
  id: Id;
  name: string;
  userIds: string[];
  emails: string[];
}

export interface ChatMessage extends Entity {
  senderId: string;
  senderEmail: string;
  text: string;
  createdAt: Date;
  readBy: string[];
  type: 'text' | 'image';
  // Para imágenes
  imageUrl?: string;
  // Metadata
  _fromCache?: boolean;
  _hasPendingWrites?: boolean;
}

export interface Edition extends Entity {
  name: string;
  type: EditionType;
  editionNumber: string;
  mapUrl?: string;
  rates: Rate[];
  extraServices: ExtraService[];
  premiumPacks: PremiumPack[];
  suckMyTrackEditionId: string;
  suckMyTrackEditionLiveUrl: string;
  isActive: boolean;
  enableInscriptions: boolean;
  enableBookings?: boolean;
  levelPricesEnabled?: boolean;
  enableNavigation: boolean;
  extraLanguages?: ExtraLanguage[];
  organizationUserIds?: string[];
  invitationsUserIds?: string[];
}

export interface Stage extends Entity {
  /** Título en castellano. Se mantiene para compatibilidad con versiones antiguas de la app. */
  title: string;
  /** Título traducido a los 5 idiomas. Es el que debe mostrarse en la app. */
  titles?: Translation;
  descriptions: Translation;
  dateTime: Date;
  location: string;
  type: StageType;
  stageNumber: number;
  hasHotel: boolean;
  hasFerry: boolean;
  editionId: string;
  imageUrl?: string;
  order: number;
}

/** Devuelve el título de la etapa en el idioma indicado, con fallback a es/en y al título legacy. */
export function getStageTitle(stage: Partial<Pick<Stage, 'title' | 'titles'>> | undefined, lang?: string): string {
  if (!stage) return '';
  const titles = stage.titles;
  if (!titles) return stage.title ?? '';
  const language = lang as Language;
  return (language && titles[language]) || titles.es || titles.en || stage.title || '';
}
